const APPLY_COOKIES_URL = '/index.php?route=common/footer/applyCookies'

export function initCookieAgreement() {
  const cookieAgreementEl = document.querySelector('.js-cookie-agreement')

  if (!cookieAgreementEl) {
    return
  }

  const btnEl = cookieAgreementEl.querySelector('.js-cookie-agreement-btn')

  btnEl.addEventListener('click', () => {
    document.querySelector('.footer__container_with-cookie').classList.remove('footer__container_with-cookie')

    fetch(APPLY_COOKIES_URL)
      .then(() => {
        cookieAgreementEl.remove()
        window.dataLayer.push({'event': 'cookie_agreed'})
      })
  })
}
